import { User } from "../interfaces/User";

export const database: User[] = [];
